// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { styled } from "@mui/material/styles";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell, { tableCellClasses } from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
// import {
//   Box,
//   Typography,
//   useMediaQuery,
//   useTheme,
//   Button,
//   IconButton,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import TJobModel from "../Utility/TJobModel";
// import EWOUpdateModal from "../Utility/EWOUpdateModal";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: "#1976d2",
//     color: theme.palette.common.white,
//     position: "sticky",
//     top: 0,
//     zIndex: 1,
//     padding: "8px 8px",
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 12,
//     wordWrap: "break-word",
//     whiteSpace: "normal",
//     padding: "8px 8px",
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme, bgcolor }) => ({
//   backgroundColor: bgcolor !== "" ? bgcolor : theme.palette.action.hover,
//   "&:last-child td, &:last-child th": {
//     border: 0,
//   },
// }));

// export default function JobCard({
//   jobData = [],
//   unassignedList,
//   selectedDate,
//   contractorCode,
// }) {
//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalEditOpen, setModalEditOpen] = useState(false);
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [selectedEditRow, setSelectedEditRow] = useState(null);
//   const [temporaryJobData, setTemporaryJobData] = useState([]);
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const fetchTemporaryJobs = async () => {
//     try {
//       const response = await axios.get("JobAllocation/LoadTempJob", {
//         params: {
//           P_DATE: selectedDate ? selectedDate.format("YYYY-MM-DD") : null,
//           P_CONTRACTOR_CODE: contractorCode,
//         },
//       });
//       if (response.data.StatusCode === 200 && response.data.ResultSet) {
//         setTemporaryJobData(response.data.ResultSet);
//       }
//     } catch (error) {
//       console.error("Error loading temporary jobs:", error);
//     }
//   };

//   useEffect(() => {
//     if (selectedDate) fetchTemporaryJobs();
//   }, [selectedDate, contractorCode]);

//   const handleRowClick = (row) => {
//     navigate("/empdetails", {
//       state: {
//         EWONO: row.EWONO || row.TEMP_EWONO,
//         JOBNO: row.JOBNO || row.TEMP_JOBNO,
//         unassignedList,
//         selectedDate: selectedDate ? selectedDate.format("YYYY-MM-DD") : null,
//         contractorCode,
//       },
//     });
//   };

//   const handleViewClick = (row) => {
//     setSelectedRow(row);
//     setModalOpen(true);
//   };

//   const handleEditClick = (row) => {
//     setSelectedEditRow(row);
//     setModalEditOpen(true);
//   };

//   const handleCloseModal = () => {
//     setModalOpen(false);
//     setSelectedRow(null);
//   };

//   const handleCloseUpdateModal = () => {
//     setModalEditOpen(false);
//     setSelectedEditRow(null);
//   };

//   const handleUpdateEwo = (newEwoNumber) => {
//     console.log("Updated EWO Number:", newEwoNumber);
//     fetchTemporaryJobs();
//   };

//   return (
//     <Box sx={{ px: 2 }}>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 2,
//         }}
//       >
//         <Typography variant="h6" sx={{ fontWeight: "bold", color: "#2196F3" }}>
//           Assigned Jobs
//         </Typography>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => navigate(-1)}
//           sx={{ textTransform: "none" }}
//         >
//           Back
//         </Button>
//       </Box>

//       <TableContainer
//         component={Paper}
//         sx={{
//           maxHeight: 260,
//           width: "100%",
//           overflowX: "auto",
//           borderRadius: "8px",
//           mb: 4,
//         }}
//       >
//         <Table stickyHeader aria-label="assigned jobs table">
//           <TableHead>
//             <TableRow>
//               <StyledTableCell
//                 align="center"
//                 style={{
//                   fontSize: 12,
//                   fontWeight: "bold",
//                   textAlign: "center",
//                 }}
//               >
//                 EWO No
//               </StyledTableCell>
//               <StyledTableCell
//                 align="center"
//                 style={{
//                   fontSize: 12,
//                   fontWeight: "bold",
//                   textAlign: "center",
//                 }}
//               >
//                 Job No
//               </StyledTableCell>
//               <StyledTableCell
//                 align="center"
//                 style={{
//                   fontSize: 12,
//                   fontWeight: "bold",
//                   textAlign: "center",
//                 }}
//               >
//                 LOC
//               </StyledTableCell>
//               <StyledTableCell
//                 align="center"
//                 style={{
//                   fontSize: 12,
//                   fontWeight: "bold",
//                   textAlign: "center",
//                 }}
//               >
//                 Status
//               </StyledTableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {jobData.map((row, index) => (
//               <StyledTableRow
//                 key={index}
//                 onClick={() => handleRowClick(row)}
//                 sx={{
//                   backgroundColor: index === 0 ? "lightblue" : "inherit",
//                   cursor: "pointer",
//                   "&:hover": { backgroundColor: theme.palette.action.hover },
//                 }}
//               >
//                 <StyledTableCell align="center">{row.EWONO}</StyledTableCell>
//                 <StyledTableCell align="center">{row.JOBNO}</StyledTableCell>
//                 <StyledTableCell align="center">{row.LOC}</StyledTableCell>
//                 <StyledTableCell align="center">{row.STS}</StyledTableCell>
//               </StyledTableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Typography
//         variant="h6"
//         sx={{ fontWeight: "bold", mb: 2, color: "#2196F3" }}
//       >
//         Temporary Jobs
//       </Typography>
//       <TableContainer
//         component={Paper}
//         sx={{
//           maxHeight: 300,
//           width: "100%",
//           overflowX: "auto",
//           borderRadius: "8px",
//         }}
//       >
//         <Table stickyHeader aria-label="temporary jobs table">
//           <TableHead>
//             <TableRow>
//               <StyledTableCell
//                 align="center"
//                 style={{ fontSize: 12, fontWeight: "bold" }}
//               >
//                 TWO No
//               </StyledTableCell>
//               <StyledTableCell
//                 align="center"
//                 style={{ fontSize: 12, fontWeight: "bold" }}
//               >
//                 Job No
//               </StyledTableCell>
//               <StyledTableCell
//                 align="center"
//                 style={{ fontSize: 12, fontWeight: "bold" }}
//               >
//                 Specification
//               </StyledTableCell>
//               <StyledTableCell
//                 align="center"
//                 style={{ fontSize: 12, fontWeight: "bold" }}
//               >
//                 Action
//               </StyledTableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {temporaryJobData.map((row, index) => (
//               <StyledTableRow
//                 key={index}
//                 onClick={() => handleRowClick(row)}
//                 sx={{
//                   cursor: "pointer",
//                   "&:hover": { backgroundColor: theme.palette.action.hover },
//                 }}
//               >
//                 <StyledTableCell align="center">
//                   {"T" + row.TEMP_EWONO.toString().padStart(5, "0")}
//                 </StyledTableCell>
//                 <StyledTableCell align="center">
//                   {row.TEMP_JOBNO}
//                 </StyledTableCell>
//                 <StyledTableCell align="center">
//                   {row.TEMP_SPEC}
//                 </StyledTableCell>
//                 <StyledTableCell align="center">
//                   <Box display="flex" alignItems="center">
//                     <IconButton
//                       color="primary"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleViewClick(row);
//                       }}
//                       aria-label="view"
//                     >
//                       <VisibilityIcon />
//                     </IconButton>
//                     <IconButton
//                       color="secondary"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleEditClick(row);
//                       }}
//                       aria-label="edit"
//                     >
//                       <EditIcon />
//                     </IconButton>
//                   </Box>
//                 </StyledTableCell>
//               </StyledTableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <TJobModel
//         open={modalOpen}
//         onClose={handleCloseModal}
//         selectedRow={selectedRow}
//       />
//       <EWOUpdateModal
//         open={modalEditOpen}
//         onClose={handleCloseUpdateModal}
//         ewoNumber={selectedEditRow?.TEMP_EWONO || ""}
//         onUpdate={handleUpdateEwo}
//         contractorCode={contractorCode}
//       />
//     </Box>
//   );
// }



// --------------------- 2026-09-25--------------------------
import React, { useEffect, useState } from "react";
import axios from "axios";
import { styled } from "@mui/material/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Button,
  IconButton,
  Chip,
  Stack,
  useTheme,
  tableCellClasses,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import TJobModel from "../Utility/TJobModel";
import EWOUpdateModal from "../Utility/EWOUpdateModal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WorkIcon from "@mui/icons-material/Work";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";

/* ---------- Styled Table Cells ---------- */
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1976d2",
    color: theme.palette.common.white,
    position: "sticky",
    top: 0,
    zIndex: 1,
    padding: "10px 8px",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.3,
    borderBottom: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "10px 8px",
    wordBreak: "break-word",
    borderBottom: "1px solid #eef2f7",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  transition: "background-color 0.15s ease",
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

/* ---------- Section Header ---------- */
const SectionHeader = ({ icon, title, count, color = "#1976d2", bg = "#e3f2fd" }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1.2,
      mt: 0.5,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: 1.5,
          backgroundColor: bg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {React.cloneElement(icon, { sx: { color, fontSize: 17 } })}
      </Box>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: { xs: 13.5, sm: 14.5 },
          color: "#16324f",
        }}
      >
        {title}
      </Typography>
    </Box>
    {count !== undefined && (
      <Chip
        label={count}
        size="small"
        sx={{
          height: 20,
          fontSize: 10.5,
          fontWeight: 700,
          backgroundColor: bg,
          color,
        }}
      />
    )}
  </Box>
);

export default function JobCard({
  jobData = [],
  unassignedList,
  selectedDate,
  contractorCode,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalEditOpen, setModalEditOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedEditRow, setSelectedEditRow] = useState(null);
  const [temporaryJobData, setTemporaryJobData] = useState([]);
  const navigate = useNavigate();
  const theme = useTheme();

  const fetchTemporaryJobs = async () => {
    try {
      const response = await axios.get("JobAllocation/LoadTempJob", {
        params: {
          P_DATE: selectedDate ? selectedDate.format("YYYY-MM-DD") : null,
          P_CONTRACTOR_CODE: contractorCode,
        },
      });
      if (response.data.StatusCode === 200 && response.data.ResultSet) {
        setTemporaryJobData(response.data.ResultSet);
      }
    } catch (error) {
      console.error("Error loading temporary jobs:", error);
    }
  };

  useEffect(() => {
    if (selectedDate) fetchTemporaryJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, contractorCode]);

  const handleRowClick = (row) => {
    navigate("/empdetails", {
      state: {
        EWONO: row.EWONO || row.TEMP_EWONO,
        JOBNO: row.JOBNO || row.TEMP_JOBNO,
        unassignedList,
        selectedDate: selectedDate ? selectedDate.format("YYYY-MM-DD") : null,
        contractorCode,
      },
    });
  };

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setModalOpen(true);
  };

  const handleEditClick = (row) => {
    setSelectedEditRow(row);
    setModalEditOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  const handleCloseUpdateModal = () => {
    setModalEditOpen(false);
    setSelectedEditRow(null);
  };

  const handleUpdateEwo = (newEwoNumber) => {
    console.log("Updated EWO Number:", newEwoNumber);
    fetchTemporaryJobs();
  };

  /* ---------- Shared table container style ---------- */
  const tableContainerSx = {
    maxHeight: { xs: 320, sm: 300 },
    width: "100%",
    overflowX: "auto",
    borderRadius: 2.5,
    border: "1px solid #e2e8f0",
    boxShadow: "0 2px 10px rgba(25, 118, 210, 0.06)",
    mb: 3,
    "&::-webkit-scrollbar": { height: 6, width: 6 },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#cbd5e1",
      borderRadius: 3,
    },
  };

  return (
    <Box sx={{ px: { xs: 0.5, sm: 1 } }}>
      {/* ================= TOP BAR ================= */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1.5,
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { xs: 14, sm: 15 },
            color: "#16324f",
          }}
        >
          Job Overview
        </Typography>
        <Button
          variant="outlined"
          onClick={() => navigate(-1)}
          startIcon={<ArrowBackIcon sx={{ fontSize: 16 }} />}
          sx={{
            textTransform: "none",
            fontSize: 12,
            fontWeight: 600,
            borderRadius: 2,
            px: 1.5,
            py: 0.5,
            minHeight: 34,
            borderColor: "#1976d2",
            color: "#1976d2",
            "&:hover": {
              backgroundColor: "#e3f2fd",
              borderColor: "#1976d2",
            },
          }}
        >
          Back
        </Button>
      </Box>

      {/* ================= ASSIGNED JOBS ================= */}
      <SectionHeader
        icon={<WorkIcon />}
        title="Assigned Jobs"
        count={jobData.length}
        color="#1976d2"
        bg="#e3f2fd"
      />

      <TableContainer component={Paper} sx={tableContainerSx}>
        <Table stickyHeader size="small" aria-label="assigned jobs table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">EWO No</StyledTableCell>
              <StyledTableCell align="center">Job No</StyledTableCell>
              <StyledTableCell align="center">LOC</StyledTableCell>
              <StyledTableCell align="center">Status</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {jobData.length > 0 ? (
              jobData.map((row, index) => (
                <StyledTableRow
                  key={index}
                  onClick={() => handleRowClick(row)}
                  sx={{
                    cursor: "pointer",
                    backgroundColor: index === 0 ? "#e3f2fd" : "inherit",
                    "&:hover": { backgroundColor: "#f1f5f9" },
                  }}
                >
                  <StyledTableCell align="center">
                    <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#16324f" }}>
                      {row.EWONO}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell align="center">{row.JOBNO}</StyledTableCell>
                  <StyledTableCell align="center">{row.LOC}</StyledTableCell>
                  <StyledTableCell align="center">
                    <Chip
                      label={row.STS || "—"}
                      size="small"
                      sx={{
                        fontSize: 10,
                        height: 22,
                        fontWeight: 600,
                        backgroundColor: "#dcfce7",
                        color: "#166534",
                      }}
                    />
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <TableRow>
                <StyledTableCell colSpan={4} align="center" sx={{ py: 3 }}>
                  <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>
                    No assigned jobs
                  </Typography>
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ================= TEMPORARY JOBS ================= */}
      <SectionHeader
        icon={<BuildCircleIcon />}
        title="Temporary Jobs"
        count={temporaryJobData.length}
        color="#ed6c02"
        bg="#fff4e5"
      />

      <TableContainer component={Paper} sx={tableContainerSx}>
        <Table stickyHeader size="small" aria-label="temporary jobs table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">TWO No</StyledTableCell>
              <StyledTableCell align="center">Job No</StyledTableCell>
              <StyledTableCell align="center">Specification</StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {temporaryJobData.length > 0 ? (
              temporaryJobData.map((row, index) => (
                <StyledTableRow
                  key={index}
                  onClick={() => handleRowClick(row)}
                  sx={{
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f1f5f9" },
                  }}
                >
                  <StyledTableCell align="center">
                    <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#ed6c02" }}>
                      {"T" + row.TEMP_EWONO.toString().padStart(5, "0")}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell align="center">{row.TEMP_JOBNO}</StyledTableCell>
                  <StyledTableCell align="center">{row.TEMP_SPEC}</StyledTableCell>
                  <StyledTableCell align="center">
                    <Stack
                      direction="row"
                      spacing={0.5}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewClick(row);
                        }}
                        sx={{
                          color: "#1976d2",
                          backgroundColor: "#e3f2fd",
                          width: 28,
                          height: 28,
                          "&:hover": { backgroundColor: "#bbdefb" },
                        }}
                      >
                        <VisibilityIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditClick(row);
                        }}
                        sx={{
                          color: "#ed6c02",
                          backgroundColor: "#fff4e5",
                          width: 28,
                          height: 28,
                          "&:hover": { backgroundColor: "#ffe0b2" },
                        }}
                      >
                        <EditIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                    </Stack>
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <TableRow>
                <StyledTableCell colSpan={4} align="center" sx={{ py: 3 }}>
                  <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>
                    No temporary jobs
                  </Typography>
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ================= MODALS ================= */}
      <TJobModel
        open={modalOpen}
        onClose={handleCloseModal}
        selectedRow={selectedRow}
      />
      <EWOUpdateModal
        open={modalEditOpen}
        onClose={handleCloseUpdateModal}
        ewoNumber={selectedEditRow?.TEMP_EWONO || ""}
        onUpdate={handleUpdateEwo}
        contractorCode={contractorCode}
      />
    </Box>
  );
}